@if (modal_name) {
<div class="modal-header">
	<h3 class="modal-title">
		{{title}} <i (click)="cancel()"
			class="fa fa-times pull-right mt-8"></i> <i class="fa pull-right mt-8"
			[ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
			style="margin-right: 10px" (click)="minimise=!minimise"></i>
	</h3>
</div>
}
<div class="modal-body" id="mainSection" [hidden]="minimise">
	<div class="entityDetails">
		<table style="width: 100%;">
			<tbody>
				<tr>
					<td class="LayerLine1" nowrap>Entity:</td>
					<td id="CRD_FORMS_CRUD_1" class="LayerData1" nowrap>{{entityData.LE_NAME}}</td>
					<td class="LayerLine1" nowrap>Business:</td>
					<td id="CRD_FORMS_CRUD_2" class="LayerData1" nowrap>
						{{entityData.ME_CODE + " " + "-" + " " + entityData.ME_NAME}}</td>
					<td class="LayerLine1" nowrap>Tax Code:</td>
					<td id="CRD_FORMS_CRUD_3" class="LayerData1" nowrap>{{entityData.TAX_CODE}}</td>
				</tr>
				<tr>
					<td class="LayerLine1" nowrap>Chart:</td>
					<td id="CRD_FORMS_CRUD_3" class="LayerData1" nowrap>{{entityData.CHART_CODE+
						" " + "-" + " " + entityData.CHART_DESC }}</td>
					<td class="LayerLine1" nowrap>Ledger:</td>
					<td id="CRD_FORMS_CRUD_4" class="LayerData1" nowrap>
						{{entityData.LEDGER }}</td>
				</tr>

			</tbody>
		</table>
	</div>





	<div id="section1" style="margin-left: 30px; margin-right: 30px">
		<div style="margin: 15px;">
			<div class="row" style="margin-top: 5px;">
			<!-- Posting G/L Account Start-->
			<div class="col-md-4">
				<label for="adj_desc">Posting G/L Account</label>
				<div>
					<select gtwSearchableSelect class="form-control input-sm"
						[(ngModel)]="postingGL"
						(change)="callFun(postingGL)"
						name="postingGL">
						<option value="">Select...</option>
						@for (s of postinggl_acct; track $index) {
<option [value]="s">{{s}}</option>
}
					</select>

					@if (postingGLError) {
<span class="form-error-container">
						Please Select a Posting G/L Account </span>
}
				</div>
			</div>




				<div class="col-md-4">
					<label for="adj_desc">Posting Tax Account Code</label>
					@if (!triggerloading) {
<div align="center" class="loading-table"
					>
						<i style="color: #e12827; font-size: 36px;"
							class="fa fa-spinner fa-spin"></i>
					</div>
}
					@if (triggerloading) {
<input type="text"
						class="form-control" [(ngModel)]="postingTax" readonly
						name="postingTax">
}
				</div>
				<!-- Posting Tax Account Code -->

				<!-- M3 Form Line -->
				<div class="col-md-4">
					<label>M3 Form Line</label>
					@if (!triggerloading) {
<div align="center" class="loading-table"
					>
						<i style="color: #e12827; font-size: 36px;"
							class="fa fa-spinner fa-spin"></i>
					</div>
}
					@if (triggerloading) {
<input type="text"
						class="form-control" [(ngModel)]="m3formline" readonly
						name="m3formline">
}
				</div>
				<!-- M3 Form Line -->
			</div>

			<div class="row" style="margin-top: 5px;">
				<!-- Book Amount -->
				<div class="col-md-4">
					<label>Book Amt</label>
					@if (!triggerloading) {
<div align="center" class="loading-table"
					>
						<i style="color: #e12827; font-size: 36px;"
							class="fa fa-spinner fa-spin"></i>
					</div>
}
					@if (triggerloading) {
<div class="input-group ">
						<span class="input-group-addon">{{dcscurr}}</span>
						<input style="text-align: right"
							type="text" class="form-control"
							[(ngModel)]="bookamt" readonly
							name="bookamt">
					</div>
}
				</div>
				<!-- Book Amount Ends-->
				<!-- Book Adjustment -->
				<div class="col-md-4">
					<label>Book Adj</label>
					@if (!triggerloading) {
<div align="center" class="loading-table"
					>
						<i style="color: #e12827; font-size: 36px;"
							class="fa fa-spinner fa-spin"></i>
					</div>
}
					@if (triggerloading) {
<div class="input-group ">
						<span class="input-group-addon">{{dcscurr}}</span>
						<input style="text-align: right"
							type="text" class="form-control"
							[(ngModel)]="bookadj" readonly
							name="bookadj">
					</div>
}
				</div>
				<!-- Book Adjustment Ends -->
				<div class="col-md-4">
					<label>Tax Adj</label>
					@if (!triggerloading) {
<div align="center" class="loading-table"
					>
						<i style="color: #e12827; font-size: 36px;"
							class="fa fa-spinner fa-spin"></i>
					</div>
}
					@if (triggerloading) {
<div class="input-group ">
						<span class="input-group-addon">{{dcscurr}}</span>
						<input
							style="text-align: right" type="text" class="form-control"
							[(ngModel)]="taxadj" readonly
							name="taxadj">
					</div>
}
				</div>
			</div>
		</div>
	</div>
	<div class="wwni-map-accordion" style="margin-top: 5px;">
	<div class="panel-default panel panel-open">
		<div class="panel-heading">
			<h4 class="panel-title">
				<a class="accordion-toggle" (click)="mandatoryFieldsOpen = !mandatoryFieldsOpen">
					Mandatory Fields <i
					class="pull-right glyphicon"
					[ngClass]="{'glyphicon-chevron-down': mandatoryFieldsOpen, 'glyphicon-chevron-up': !mandatoryFieldsOpen}">
				</i>
				</a>
			</h4>
		</div>
		<div [hidden]="!mandatoryFieldsOpen" class="panel-collapse">
			<div class="panel-body">
				<div class="row">
			<div class="col-md-3">
				<label for="adj_desc">Template</label>
				<div>
					<select gtwSearchableSelect class="form-control input-sm"
						(change)='changeTemplate()' [(ngModel)]="template"
						name="template">
						<option value="">Select...</option>
						@for (s of tempsystemaccount; track $index) {
<option [value]="s">{{s}}</option>
}
					</select>
					@if (templateError) {
<span class="form-error-container">
						Please Select a Template </span>
}
				</div>
			</div>

					<div class="col-md-3">
						<label for="adj_description">User M-1 Description</label>
						@if (template != '' && template != '----------Preferred Templates---------' && template != '-------Non Preferred Templates-------') {
<div
						>
							<input (change)='m1Desc()' type="text" class="form-control"
								name="userm1_desc" id="userm1_desc" [(ngModel)]="userm1"
								placeholder="" required>
						</div>
}
						@if (template == '' || template == '----------Preferred Templates---------' || template =='-------Non Preferred Templates-------') {
<div
						>
							<input (change)='m1Desc()' type="text" class="form-control"
								name="userm1_desc" id="userm1_desc" [(ngModel)]="userm1"
								placeholder="" required readonly>
						</div>
}
						@if (userDescError) {
<span class="form-error-container">User
							M-1 Description is required</span>
}
					</div>

				<div class="col-md-3">
					<label for="adj_description">SchdM Type</label>
					<div>
						@if (template != '' && template != '----------Preferred Templates---------' && template != '-------Non Preferred Templates-------') {
<select [(ngModel)]="schdmt" (change)="typeChange()"
						
							class="form-control"
							name="schdmt">
							<option value="">Select...</option>
							@for (j of schdmtype; track $index) {
<option [value]="j">{{j}}</option>
}
						</select>
}
						@if (template == '' || template == '----------Preferred Templates---------' || template =='-------Non Preferred Templates-------') {
<div
						>
							<input (change)='m1Desc()' type="text" class="form-control"
								name="userm1_desc" id="userm1_desc" [(ngModel)]="schdmt"
								placeholder="" required readonly>
						</div>
}
						@if (typeError) {
<span class="form-error-container">Please
							Select a SchdM type</span>
}
					</div>

				</div>
				<div class="col-md-3">
					<label>TBBS Acct </label>
					<div>
						@if (template != '' && template != '----------Preferred Templates---------' && template != '-------Non Preferred Templates-------') {
<select gtwSearchableSelect [(ngModel)]="tbbsacctval" (change)="tbbsChange()"
						
							class="form-control input-sm"
							name="tbbsacctval">
							<option value="">Select...</option>
							@for (t of tbbsacct; track $index) {
<option [value]="t">{{t}}</option>
}
						</select>
}
						@if (template == '' || template == '----------Preferred Templates---------' || template =='-------Non Preferred Templates-------') {
<div
						>
							<input type="text" class="form-control" name="userm1_desc1"
								id="userm1_desc1" [(ngModel)]="tbbsacctval" placeholder=""
								required readonly>
						</div>
}
						@if (tbbsError) {
<span class="form-error-container">Please
							Select a TBBS Acct</span>
}

					</div>

				</div>

				</div>

				<div class="row" style="margin-top: 5px;">
					<div class="col-md-3">
						<label for="adj_description">Begin Year</label>
						<div>
							@if (!readonlybeginyear) {
<input (blur)='beginYearChange()' type="number"
						
								class="form-control" name="begin_year" id="begin_year"
								[(ngModel)]="beginYear"  step="1"
								placeholder="" required>
} @if (beginYearError && !readonlybeginyear) {
<span
								class="form-error-container">
								Begin Year must be greater than or equal to
								{{currentTaxYear}} </span>
}
							@if (readonlybeginyear) {
<input type="number"
						
								class="form-control" name="begin_year" id="begin_year"
								[(ngModel)]="beginYear"  step="1"
								placeholder="" readonly>
}
						</div>
					</div>

					<div class="col-md-3">
						<label for="adj_description">End Year</label>
						<div>
							<input (blur)='endYearChange()' type="number"
								class="form-control" name="end_year" id="end_year"
								[(ngModel)]="endYear" [min]="beginYear" step="1"
								placeholder="" required> @if (endYearError) {
<span
								class="form-error-container"> End
								Year must be greater than or equal to {{beginYear || 'begin
								year'}} </span>
}
								@if (endYearErrormaxyear) {
<span
								class="form-error-container"> End
								Year must be less than or equal to {{beginYear + 50 || 'begin
								year'}} </span>
}
						</div>
					</div>
					<div class="col-md-4 noWrap numText">
						<label>Annual Adjustment Amount</label>
						<div class="input-group ">
							<span class="input-group-addon">{{dcscurr}}</span> <input
								style="text-align: right" name="annual_adj_amt"
								class="form-control"
								(blur)="annual_adjustment_amount_change()"
								aria-describedby="basic-addon2"
								[(ngModel)]="annual_adjustment_amount">
						</div>
						@if (annual_adjustment_amount_error) {
<span class="form-error-container"
						> Annual
							Adjustment Amount cannot be empty </span>
}
					</div>
				</div>
			</div>
		</div>
	</div>
	</div>
	<div style="width: 60%">
		@if (canViewAdjustmentSchedule) {
<div class="wwni-map-accordion"
		>
		<div class="panel-default panel panel-open">
			<div class="panel-heading">
				<h4 class="panel-title">
					<a class="accordion-toggle" (click)="adjustmentScheduleOpen = !adjustmentScheduleOpen">
						View adjustment
			Schedule <i class="pull-right glyphicon"
					[ngClass]="{'glyphicon-chevron-down': adjustmentScheduleOpen, 'glyphicon-chevron-up': !adjustmentScheduleOpen}">
				</i>
					</a>
				</h4>
			</div>
			<div [hidden]="!adjustmentScheduleOpen" class="panel-collapse">
				<div class="panel-body">
					<div class="row" style="margin-top: 5px;">
						<div class="col-md-2">
							<label>Tax Year</label>
						</div>
						<div class="col-md-6" style="text-align: center">
							<label>Adjustment Amount</label>
						</div>
					</div>
					@for (adjRecord of viewAdjustmentScheduleArray; track $index) {
<div class="row" style="margin-top: 5px;"
					>
						<div class="col-md-2">
							<label>{{adjRecord.year}}</label>
						</div>
						<div class="col-md-6">
							<div class="input-group">
								<span class="input-group-addon">{{dcscurr}}</span> @if (adjRecord.readonlyflag) {
<input
									style="text-align: right" class="form-control"
									aria-describedby="basic-addon2" [(ngModel)]="adjRecord.value"
								
									[name]="'adjValue_' + $index"
									readonly>
} 
									@if (!adjRecord.readonlyflag) {
<input
									style="text-align: right" class="form-control"
									aria-describedby="basic-addon2" [(ngModel)]="adjRecord.value"
								
									[name]="'adjValue_' + $index">
}@if (!adjRecord.readonlyflag) {
<span 
									class="input-group-addon">
									<button  type="button"
										style="border: none; padding: 0; background: none;"
										(click)="applyButton($index)">Apply</button>
								</span>
}
							</div>
						</div>
					</div>
}
				</div>
			</div>
		</div>
		</div>
}
	</div>
</div>
@if (modal_name) {
<div class="modal-footer"
	[hidden]="minimise">
	<button class="btn  btn-info btn-sm" type="button"
		(click)="save()">
		@if (crudLoading) {
<span> <i class="fa fa-spinner fa-pulse"></i>
		</span>
} Save
	</button>
	<button class="btn btn-danger-outline btn-sm" type="button"
		(click)="reset()">Reset</button>
	<button class="btn btn-warning btn-sm" type="button"
		(click)="cancel()">Cancel</button>
</div>
}
<!-- Existing Adjustments -->
<div class="existing-adjustments-section"
	[hidden]="minimise">
	<div class="table-responsive existing-adjustments-container">
		<table
			class="table table-hover table-bordered table-striped table-condensed">
			<thead>
				<tr>
					<th style="text-align: center;">Edit</th>
					<th>Posting Account</th>
					<th>SchdM Desc</th>
					<th>SchdM Type</th>
					<th>Last Updated</th>
					<th>Updated By</th>
				</tr>
			</thead>
			@if (main_existing_data_loading) {
<tbody>
				<tr>
					<td class="loading-table" colspan="6"><i
						style="margin-top: 20px" class="fa fa-2x fa-spinner fa-pulse"></i>
					</td>
				</tr>
			</tbody>
}
		@if (noRecords && !main_existing_data_loading) {
<tbody>
			<tr>
				<td class="loading-table" colspan="6"><div
						style="margin-top: 40px">
						<b>No Existing Adjustments</b>
					</div></td>
			</tr>
		</tbody>
}
		@if (!noRecords && !main_existing_data_loading) {
<tbody>
			@for (adjs of getUniqueAdjs(mainExistingData, 'SCHDM_ID'); track $index) {
<tr>
				<td style="text-align: center;"
					(click)="loadAdjustment(adjs)"><span> <a href="javascript:void(0)">
							<i class="fa fa-pencil"></i> Edit
					</a>
				</span></td>
				<td>{{adjs.POSTING_ACCT_DESC}}</td>
				<td>{{adjs.SCHDM_DESC}}</td>
				<td>{{adjs.SCHDM_TYPE}}</td>
				<td>{{adjs.UPDATED_ON}}</td>
				<td>{{adjs.UPDATED_BY}}</td>
			</tr>
}
		</tbody>
}
		</table>
	</div>
</div>
